var map = {
	"./stage1.svg": "aede",
	"./stage2.svg": "ebbe",
	"./stage3.svg": "ebbe9",
	"./stage4.svg": "af3a",
	"./stage5.svg": "d2ac",
	"./stage6.svg": "6371"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8325";